// extracted by mini-css-extract-plugin
export default {"centeredModal":"RejectUserModal_centeredModal__5zZKx","ant-modal":"RejectUserModal_ant-modal__x09r1","ant-modal-content":"RejectUserModal_ant-modal-content__2WQRp"};